import "./main.js";
import "./pagination.js";
import "./filters.js";
import "./media_upload.js";

/******************* Django i18n *******************/

// This is just a check to see whether Django jsi18n has been loaded, to give a
// clear error message rather than (or at least before) a bunch of confusing
// errors later on.
if (!window.django) {
  console.error("window.django not defined - ensure Django's jsi18n is loaded before this script")
}
